module.exports = __webpack_public_path__ + "img/POSITANO_S.10156d68.png";